'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useParams, useRouter } from 'next/navigation';

function FanRankingTabsContainer() {
  const params = useParams<{ id: string }>();
  const channelId = params?.id ? decodeURIComponent(params.id) : '';
  const router = useRouter();
  return (
    <PageTabsContainer className='mb-10' contentClassName='w-full'>
      <PageTab
        includedURLPath='/ranking/all'
        onClick={() => router.push(`/channel/${channelId}/ranking/all`)}
        isMiddleLine
        className='ml-0'
      >
        {'전체랭킹'}
      </PageTab>
      <PageTab
        includedURLPath='/ranking/monthly'
        onClick={() => router.push(`/channel/${channelId}/ranking/monthly`)}
        isMiddleLine
      >
        {'월별랭킹'}
      </PageTab>
    </PageTabsContainer>
  );
}

export default FanRankingTabsContainer;
